import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { OnboardingDetailsDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Return = {
  getOnboardingDetails: (userId: string) => Promise<OnboardingDetailsDto>;
  isGettingOnboardingDetails: boolean;
};

export const useGetUserOnboardingDetails = (): Return => {
  const { onboardingApi } = useApiClient();
  const { isPending, mutateAsync } = useMutation<OnboardingDetailsDto, AxiosError, string>({
    meta: { disableErrorAlert: true, disableSuccessAlert: true },
    mutationFn: async userId => {
      const res = await onboardingApi.getOnboardingDetails(userId);
      return res.data;
    },
    mutationKey: [QueryKeyEnum.USERS.ONBOARDING_DETAILS],
  });

  return {
    getOnboardingDetails: mutateAsync,
    isGettingOnboardingDetails: isPending,
  };
};
